import { render } from "./ReinstatementSection.vue?vue&type=template&id=b06bcbb4&scoped=true&ts=true"
import script from "./ReinstatementSection.vue?vue&type=script&lang=ts"
export * from "./ReinstatementSection.vue?vue&type=script&lang=ts"

import "./ReinstatementSection.vue?vue&type=style&index=0&id=b06bcbb4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06bcbb4"]])

export default __exports__